import axios from "../utils/axios";

export const getUsers = (payload) => {
    return axios.post(`/User/GetUsers?PageSize=${payload.pageSize}&PageNumber=${payload.pageNumber}`, payload.data);
};

export const updateUsers = (payload) => {
    return axios.post(`/User/Update`, payload);
};

export const deleteUsers = (payload) => {
    return axios.post(`/User/Delete`, payload);
};

export const addUsers = (payload) => {
    return axios.post(`/User/Add`, payload);
};

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getUserMenuList = () => {
    return axios.get(`/User/GetUserMenuList`);
};

export const getUserPlantList = (userCode) => {
    return axios.get(`/User/GetUserPlantList?userCode=${userCode}`);
};

export const getUserInfo = (userCode) => {
    return axios.get(`/User/GetUserInfo?userCode=${userCode}`);
};

export const getUserInterfaceList = () => {
    return axios.get(`/User/GetUserInterfaceList`);
};

export const getUserDetailByID = (id) => {
    return axios.get(`/User/GetUserDetailById`, { params: { id: id } });
};

export const getUserGroupList = () => {
    return axios.get(`/UserGroup/GetList`);
};

export const getUserRoleGroupList = () => {
    return axios.get(`/RoleGroup/GetList`);
};

export const getEquipmentReportGroupList = () => {
    return axios.get(`/EquipmentReportGroup/GetList`);
};

export const getCostCenterList = () => {
    return axios.get(`/CostCenter/GetCostCenterList`);
};

export const postMaintenanceApprovalRights = (payload) => {
    return axios.post(`/User/${payload.userId}/maintenance-approval-rights`, payload.data); // when dispatch http url replicate with /MostApi/api
};

export const getMaintenanceApprovalRights = (userId) => {
    return axios.get(`/User/${userId}/maintenance-approval-rights`); // when dispatch http url replicate with /MostApi/api
};

export const checkUserRole = (roleFunctionCode) => {
    return axios.get(`/User/CheckUserRole?roleFunctionCode=${roleFunctionCode}`);
};

export const updateUserGroupsbyid = (payload) => {
    return axios.post(`/User/UpdateGroupsOfUser?userId=${payload.id}`, payload.data);
};
export const updateUserRoleGroupsbyid = (payload) => {
    return axios.post(`/User/UpdateRoleGroupsOfUser?userId=${payload.id}`, payload.data);
};
export const getTechnicianListByPoolId = (payload) => {
    return axios.get(`/User/GetTechnicianListByPoolId?poolId=${payload}`);
};

export const getTechnicianList = () => {
    return axios.get(`/User/GetTechnicianList`);
};